import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQueryWithReauth } from "../../app/utils"
import { FileFeatureFact, FileFeatureFeature } from "@dialogics/shared/dto/types.ts"
import { FileFeature2 } from "@prisma/client"

export const fileFeatureApi = createApi({
  reducerPath: "fileFeatureApi",
  baseQuery: baseQueryWithReauth({ baseUrl: "/api/file-feature/" }),
  endpoints: builder => ({
    getFileFeature: builder.query<FileFeature2 & { facts: FileFeatureFact; features: FileFeatureFeature }, number>({
      query: id => `${id}`,
    }),
  }),
})

export const { useLazyGetFileFeatureQuery } = fileFeatureApi
